import { CustomerInvoicesService } from "./../../../services/documents/CustomerInvoicesService";
import React from "react";
import { IAppEntity } from "../../entities";
import { DocumentService } from "../../../services/documents/DocumentService";
import { ICreateCustomerInvoicesDto } from "../../../components/Pages/Documents/CustomerInvoices/dtos/ICreateCustomerInvoicesDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupCustomerInvoices } from "../../../components/Shared/NewForms/NFLookupCustomerInvoices";
import { CustomerInvoiceDetail } from "src/components/Pages/Documents/CustomerInvoices/components/CustomerInvoicesDetail";
import CustomerInvoicesList from "src/components/Pages/Documents/CustomerInvoices/components/CustomerInvoicesList";

export const CustomerInvoices: IAppEntity = {
  entityType: "document",
  title: "Customer Invoices",
  pluralTitle: "Customer Invoices",
  apiUrl: "CustomerInvoices",
  apiEnum: ReferenceTypes.DocumentCustomerInvoice,
  getDetailView: (id?: string) => {
    return React.createElement(CustomerInvoiceDetail, {
      id: id
    });
  },
  getDetailViewComponent: (model: any, modelUpdatedEvent: (model: any) => void) => React.createElement(React.Fragment, {}),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(CustomerInvoicesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupCustomerInvoices, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog
    });
  },
  getDataService: () => new CustomerInvoicesService("CustomerInvoices"),
  getEmptyModel: () => {
    const model: ICreateCustomerInvoicesDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      documentNumber: "",
      status: 0,
      createdDate: new Date(),
      approvalDate: new Date(),
    //   products: [],
    //   services: [],
    //   paymentOffsets: []
    };
    return model;
  }
};
